<div class="margin5" [formGroup]="form">
  <div fxLayout="row" fxLayoutAlign="center center">
    
  <div fxLayout="row" fxLayoutAlign="space-evenly center" >
    <div matRipple fxLayoutAlign="center center" class="divIcon"(click)="toDay()">
      <mat-icon  class="iconButton"  matTooltip="oggi"
        >
        today
      </mat-icon>
    </div>

    <div matRipple fxLayoutAlign="center center" class="divIcon"  (click)="previousDay()">
      <mat-icon  class="iconButton" matTooltip="Precedente">
        chevron_left
      </mat-icon>
    </div>
    <div class="text meseTitle">
      <mat-form-field [appearance]="appearance" class="width100 fieldMese">
        <input matInput readonly [matDatepicker]="picker" [placeholder]="item.placeholder!"
          [formControlName]="item.formControlName">
        <mat-datepicker #picker startView="year"></mat-datepicker>
      </mat-form-field>

      <mat-datepicker #picker></mat-datepicker>
    </div>
    <div matRipple fxLayoutAlign="center center" class="divIcon" (click)="nextDay()">
      <mat-icon class="iconButton" matTooltip="Successivo" >
        chevron_right
      </mat-icon>
    </div>

    <div matRipple fxLayout="row" fxLayoutAlign="center center" class="divIcon"  (click)="picker.open()">
      <mat-icon  class="iconButton" matTooltip="Scegli Data">
        calendar_month
      </mat-icon>
    </div>
  </div>
</div>